// src/components/Sections/TournamentExperienceSection/TournamentExperienceSection.jsx

import React from 'react';
import './TournamentExperienceSection.scss';

import seriesScreenshot from '../../../assets/images/marketing/ttg-tour-series-phone.png';

import useInView from '../../../hooks/useInView';

const seriesStops = [
  {
    number: '01',
    course: 'Deerfield',
    state: 'complete'
  },
  {
    number: '02',
    course: 'Royal Ontario',
    state: 'upcoming'
  },
  {
    number: '03',
    course: "Piper's Heath",
    state: 'upcoming'
  },
  {
    number: '04',
    course: 'Crosswinds',
    state: 'upcoming'
  },
  {
    number: '05',
    course: 'BraeBen',
    state: 'upcoming'
  }
];

export default function TournamentExperienceSection() {
  const {
    ref,
    isVisible
  } = useInView({
    threshold: 0.22
  });

  return (
    <section
      id="tournaments"
      ref={ref}
      className={`
        series-v4
        section-v2
        motion-section
        ${isVisible ? 'is-visible' : ''}
      `}
    >
      <div className="container series-v4__layout">
        <div className="series-v4__copy motion-copy">
          <p className="eyebrow">
            03 · Tour Series
          </p>

          <h2>
            A Tour Series on your schedule.
          </h2>

          <p>
            Join a multi-course competition, play each participating stop
            when it suits you, and submit your round toward a shared
            handicap-adjusted leaderboard. You do not need to coordinate
            one tournament day with every other member.
          </p>

          <div className="tournament-copy-steps">
            <span>
              Join
            </span>

            <i aria-hidden="true"></i>

            <span>
              Play
            </span>

            <i aria-hidden="true"></i>

            <span>
              Move up the board
            </span>
          </div>

          <p className="experience-quote">
            Your schedule. A shared competition.
          </p>
        </div>

        <div className="series-v4__visual">
          <span
            className="series-v4__ghost"
            aria-hidden="true"
          >
            TOUR
          </span>

          {/* SERIES ROUTE */}

          <div
            className="series-v4__route"
            aria-hidden="true"
          >
            <div className="series-v4__route-header">
              <small>
                Example Series
              </small>

              <strong>
                5 sample stops · Net scoring
              </strong>
            </div>

            <div className="series-v4__route-stops">
              {seriesStops.map((stop, index) => (
                <div
                  className={`
                    series-v4__stop
                    series-v4__stop--${stop.state}
                  `}
                  key={stop.number}
                  style={{
                    '--stop-index': index
                  }}
                >
                  <span>
                    {stop.number}
                  </span>

                  <strong>
                    {stop.course}
                  </strong>

                  <i></i>
                </div>
              ))}
            </div>
          </div>

          {/* PHONE */}

          <figure className="series-v4__phone">
            <img
              src={seriesScreenshot}
              alt="The Tour Golfers Tour Series season progress"
              loading="lazy"
            />
          </figure>

          <div className="series-v4__stamp">
            <span>
              Series Stop
            </span>

            <strong>
              01
            </strong>

            <small>
              Complete
            </small>
          </div>
        </div>
      </div>
    </section>
  );
}